/*************************************************/
/* NEWS                                          */
/*************************************************/

export function news($body, bodyLoadingClass, currentCulture) {
    let $newsContainer,
        $lazyLoadButton,
        $lazyLoadContainer,
        $newsListContainer,
        pageSize,
        totalSize,
        newsPageId,
        newsControllerUrl,
        filters,
        currentFilter,
        activeClass,
        itemsToSkip;

    const init = function () {
        $newsContainer = $(".site-section--news .news-section"),
            $lazyLoadButton = $newsContainer.find(".news-items__load-more"),
            $lazyLoadContainer = $lazyLoadButton.parent(".news-items__cta"),
            $newsListContainer = $newsContainer.find(".news-items"),
            filters = $('input[name="news-filter"]'),
            currentFilter = getFilterQuery(),
            activeClass= 'current';
            pageSize = $newsContainer.data("newslist-pagesize"),
            totalSize = $newsContainer.data("newslist-totalsize"),
            newsPageId = $newsContainer.data("newspage-id"),
            newsControllerUrl = "/umbraco/surface/news/getnewslistpage",
            itemsToSkip = 0;

        filters.closest('label').removeClass(activeClass);
        if (currentFilter !== null) {
            var filter = $('input[name="news-filter"][value="' + currentFilter + '"]');
            totalSize = filter.attr('data-listsize');
            filter.prop("checked", true);
            filter.closest('label').addClass(activeClass);
        }

        filters.on('change', function () {
            filters.closest('label').removeClass(activeClass);
            currentFilter = this.value;
            setFilterQuery(currentFilter);
            totalSize = $(this).attr('data-listsize');
            $lazyLoadContainer.show();

            itemsToSkip = 0;
            $(this).closest('label').addClass(activeClass);
            loadNews(false);
        });

        $lazyLoadButton.on('click', function () {
            if (itemsToSkip === 0) {
                itemsToSkip = pageSize;
            }
            loadNews(true);
        });

        window.onpopstate = function (event) {
            currentFilter = getFilterQuery();
            loadNews(false);
        }

    };

    const loadNews = function (incrementPageSize) {
        $body.addClass(bodyLoadingClass);
        $.get(newsControllerUrl,
            {
                newsPageId: newsPageId,
                itemsToSkip: itemsToSkip,
                pageSize: pageSize,
                businessArea: currentFilter,
                cultureCode: currentCulture
            }
        ).done(function (data) {
            if ($.trim(data)) {
                if (incrementPageSize) {
                    $newsListContainer.append(data);
                    //Add page size to items to skip count
                    itemsToSkip += pageSize;
                    //If there are no more items to fetch, remove the button
                    if (itemsToSkip >= totalSize) {
                        $lazyLoadContainer.hide();
                    }
                } else {
                    $newsListContainer.html(data);

                }
            } else {
                $lazyLoadContainer.hide();
                console.log("Response was empty");
            }
        }).fail(function (xhr, status, error) {
            console.log("An error occured fetching the item page");
        }).always(function () {
            $body.removeClass(bodyLoadingClass);
        });
    };

    const getFilterQuery = function () {
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search);

            if (searchParams.has("filter")) {
                return searchParams.get("filter");
            } 
        }
        return null;
    }

    const setFilterQuery = function (filter) {
        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("filter", filter);
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState('', '', newRelativePathQuery);
        }
    }

    init();

    if ($newsContainer.length) {
        loadNews(false);
    }
}



// WEBPACK FOOTER //
// ./src/scripts/partials/news.js